var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TheTopBar',{attrs:{"controls":_vm.controls,"with-fullscreen-button":"","menu-offset":_vm.menuOffset},scopedSlots:_vm._u([{key:"pointer-events-disabled-relative-slot",fn:function(){return [(!!_vm.labelText)?_c('TopBarLabel',{attrs:{"align":"right"}},[_vm._v(" "+_vm._s(_vm.labelText)+" ")]):_vm._e()]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }